import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartDumbbell } from './useGetChartDumbbell'
import { ChartDumbbellContent } from './ChartDumbbellContent'

export const ChartDumbbellComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartDumbbell(id, tileFilterSelections)

  return (
    <ChartDumbbellContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartDumbbellComponentLoading() {
  return 'Loading...'
}
